export const TIMESHEET_CONSTANTS = {
  IMAGES: {
    NO_DATA_FOUND: 'assets/img/no-data-found.png',
  },
  MODAL_CLASSES: {
    DIM_BACKGROUND: 'dim-background',
  },
  CSS_CLASSES: {
    RED_TEXT: 'red-text',
    BLACK_TEXT: 'black-text',
    GREEN_TEXT: 'green-text',
  },
  LABELS: {
    SEARCH: 'Search',
    SELECT_ITEM: 'Select Item',
    GET_CALENDAR: 'Get Calendar',
    HOURS_SUFFIX: ' Hrs',
  },
  TEMPLATE: {
    HOURS_SUFFIX: ' Hrs',
    HOURS_SHORT: 'Hrs'
  },
  MESSAGES: {
    FAILED_LOAD_COMMENTS: 'Failed to load leave comments',
    FAILED_LOAD_TIMESHEET: 'Failed to load timesheet details',
    FAILED_SAVE_COMMENT: 'Failed to save comment',
    COMMENT_SAVED_SUCCESS: 'Comment saved successfully',
    FAILED_UPDATE_TIMESHEET_STATUS: 'Failed to update timesheet status',
    NO_PENDING_SUBMISSIONS: 'No pending submissions at this time.',
    NO_PENDING_APPROVALS: 'No pending approvals at this time.',
  },
  TITLES: {
    SUCCESS: 'Success',
    ERROR: 'Error',
    LOAD_ERROR: 'Load Error',
    SAVE_ERROR: 'Save Error',
  },
  API_ENDPOINTS: {
    HIRING_LEAVE_COMMENTS: '/vendor/leave-summary',
  },
  POSITION_STYLES: {
    INITIAL_TOP: '0px',
    INITIAL_LEFT: '0px',
  },
  STATUS: {
    PENDING_SUBMISSION: 'Pending Submission',
    PENDING_APPROVAL: 'Pending Approval',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
  },
  HOURS_SUFFIX: ' Hrs',
  BILLING_CONFIRMATION_DIALOG: {
    TITLE: 'Calculate Billing Hours',
    SUBMIT_LABEL: 'Proceed',
    CANCEL_LABEL: 'Cancel',
    MESSAGE: 'Do you want to calculate billing hours for this employee?',
  },
  EXCLUDE_CONFIRMATION_DIALOG: {
    TITLE: 'Exclude from Timesheets',
    SUBMIT_LABEL: 'Confirm',
    CANCEL_LABEL: 'Cancel',
    MESSAGE: 'This employee will not be included in future timesheets. Do you want to proceed?',
  },
  DELETE_CONFIRMATION_DIALOG: {
    TITLE: 'Delete Timesheet',
    SUBMIT_LABEL: 'Delete',
    CANCEL_LABEL: 'Cancel',
    MESSAGE: 'Are you sure you want to delete this timesheet record?',
  },
} as const;
